export const SET_FIRST_NAME = 'app/profiles/set/first_name';
export const SET_LAST_NAME = 'app/profiles/set/last_name';
export const SET_BIRTHDATE = 'app/profiles/set/birthdate';
export const CLEAR_STATE = 'app/profiles/clear_state';
